<div class="button-menu-container">
    <button mat-raised-button [class]="classList" [matMenuTriggerFor]="menu">
        <div class="flex items-center">
            <span>{{ title }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
        </div>
    </button>
</div>

<mat-menu #menu="matMenu">
    @for (option of options; track option.title) {
        <button
            mat-menu-item
            (click)="option.action()"
            [disabled]="option.disabled"
        >
            <span>{{ option.title }}</span>
        </button>
    }
</mat-menu>
